const Resources = {

    table_headers: [
        { 
          text: 'Name',
          align: 'start',
          value: 'associate_name',
          type:  'link',
        },
        {
            text: 'Email',
            value: 'email'
        },
        {
            text: 'Shift',
            value: 'shift_name'
        },
        {
            text:   'Reports to',
            value:  'reports_to',
        },
        {
            text:   'Role',
            value:  'role',
        },
        {
            text:   'Total Permissions',
            value:  'total_permissions',
            type: 'total_permissions'
        },
        {
            text: 'Permissions',
            type: 'link_action',
            value: 'See permissions'
        }
    ],

    table_new_users_headers:
    [
        { 
            text: 'Name',
            align: 'start',
            value: 'name_concat',
            type:  'text_bold',
        },
        {
            text: 'Email',
            value: 'email'
        },
        {
            text: 'Role',
            value: 'role'
        },
        {
            text: 'Email already sent',
            value: 'email_sent',
            type: 'boolean',
        },
        {
            text: 'Token link',
            value: 'token',
            type: 'copy',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates',
            href:   '/associates',
            arrow:  "",
        },
    ],

    excel_file_headers: {
        'First name': 'first_name',
        'Last name': 'last_name',
        'Address 1': 'address1:',
        'Address 2': 'address2:',
        'City': 'city',
        'State': 'state',
        'Role': 'role_id',
        'Permissions Template': 'permissions_template_id',
        'Reports to': 'report_associate_id',
        'Zip code': 'zip_code',
        'Phone': 'phone1',
        'Phone 2': 'phone2',
        'Emergency phone': 'emergency_phone',
        'Email': 'email',
        'Birth date': 'birth_date',
        'Pager number': 'pager_number',
        'Shift': 'shift',
        'Active': 'status',
        'Hours': 'hours',
        'Associate ID': 'associate_number',
        'Hire date': 'hire_date',
        'Next evaluation': 'next_evaluation',
        'Hourly pay': 'hourly_pay',
        'Position': 'position_id',
        'Contact Type': 'contract_type_id',
        'Department': 'cost_center_department_id',
        'Department date of hire': 'department_hire_date',
        'Comments': 'comments'
    },

    excel_fields_required: {
        first_name: true,
        last_name: true,
        address1: false,
        address2: false,
        city: false,
        state: false,
        role_id: true,
        permissions_template_id: true,
        zip_code: false,
        phone1: false,
        phone2: false,
        emergency_phone: false,
        email: true,
        birth_date: false,
        pager_number: false,
        shift: false,
        status: false,
        hours: false,
        associate_number: false,
        hire_date: false,
        next_evaluation: false,
        hourly_pay: false,
        position_id: false,
        contract_type_id: false,
        cost_center_department_id: false,
        department_hire_date: false,
        comments: false,
    },

    empty_format_data: [
        { 
            first_name:                 '',
            last_name:                  '',
            address1:                   '',
            address2:                   '',
            city: '',
            state: '',
            role_id:                    '',
            permissions_template_id:    '',
            zip_code:                   '',
            phone1:                     '',
            phone2:                     '',
            emergency_phone:            '',
            email:                      '',
            birth_date:                 '',
            pager_number:               '',
            shift:                      'Day',
            status:                     false,
            hours:                      '',
            associate_number:           '',
            hire_date:                  '',
            next_evaluation:            '',
            hourly_pay:                 '',
            position_id:                '',
            contract_type_id:           '',
            cost_center_department_id:  '',
            department_hire_date:       '',
            comments:                   '',
        },
    ],

    helps: [
        {
            label: '¿How to Enable New Users to Log In?', 
            instruction: `https://scribehow.com/embed/How_to_Add_New_Users_on_Digital_Solutions__CH7iiHEjQKi6HhPEWpkUXA?as=scrollable`
        },
        {
            label: '¿How to Add a New Associate?', 
            instruction: `https://scribehow.com/embed/Add_a_New_Associate__lRkNSyuzQ3iCVROAlNswuw?as=scrollable`
        },
        {
            label: '¿How to add a Permission Template?', 
            instruction: `https://scribehow.com/embed/Add_a_Permission_Template__Vl4zfeksSlmIAQ8ZrCsx8Q?as=scrollable`
        },
        {
            label: '¿How to Mass Edit Associates?', 
            instruction: `https://scribehow.com/embed/How_To_Mass_Edit_Associates_In_Digital_Solutions__nOdzK82xTQGAs1XLq-oD0w?as=scrollable`
        },
        {
            label: '¿How to Mass Delete Associates?', 
            instruction: `https://scribehow.com/embed/How_to_Mass_Delete_Associates__s3pmBw2uSsO8KGqs7aAdcA?as=scrollable`
        },
        {
            label: '¿How to Mass Delete Permission Templates?', 
            instruction: `https://scribehow.com/embed/How_To_Mass_Delete_Templates__fC5_GAHLRw2qAkTUEJPJkQ?as=scrollable`
        },
    ]

}

export default Resources;